'use client';

import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import { ThemeProvider } from './context/ThemeContext';
import { HistoryOverrideProvider } from './context/HistoryOverrideContext';
import SearchProviderConfig from './components/SearchProviderConfig/SearchProviderConfig';
import SearchUI from './components/SearchUI/SearchUI';
import VehicleDetail from './pages/VehicleDetail';
import CookieConsentBanner from './components/CookieConsentBanner';
import { LoginGate } from './components/LoginGate/LoginGate';
import posthog from 'posthog-js';

function usePageView() {
  const location = useLocation();
  useEffect(() => {
    const utm_source =
      new URLSearchParams(window.location.search).get('utm_source') || 'native';
    posthog.capture('$pageview', { path: location.pathname, utm_source });
  }, [location]);
}

function useTimeSpent() {
  useEffect(() => {
    const utm_source =
      new URLSearchParams(window.location.search).get('utm_source') || 'native';
    const interval = setInterval(() => {
      posthog.capture('time_spent', { seconds: 30, utm_source });
    }, 30000);
    return () => clearInterval(interval);
  }, []);
}

const AppRoutes: React.FC = () => {
  usePageView();
  useTimeSpent();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <SearchProviderConfig>
            <SearchUI />
          </SearchProviderConfig>
        }
      />
      <Route path="/vehicle/:id" element={<VehicleDetail />} />
      {/* /history route removed — history is now shown inline on the search page */}
    </Routes>
  );
};

const App: React.FC = () => (
  <ThemeProvider>
    <Router>
      <HistoryOverrideProvider>
        <LoginGate>
          <>
            <AppRoutes />
            <CookieConsentBanner />
          </>
        </LoginGate>
      </HistoryOverrideProvider>
    </Router>
  </ThemeProvider>
);

export default App;